import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../services/analytics";

export default function GAListener() {
	const location = useLocation();
	const lastPage = useRef(null);

	useEffect(() => {
		const page = location.pathname + location.search;
		if (lastPage.current === page) return;
		lastPage.current = page;
		trackPageView(page);
	}, [location.pathname, location.search]);

	return null;
}
